import React, { useEffect, useState } from "react";
import LZString from 'lz-string';

export const AuthContext = React.createContext();

export default function AuthProvider({ children }) {
const[persantage,setPersantage]= useState([])
const[questionsAnswers,setQuestionsAnswers]=useState(null)
const [result,setResult]= useState(null)

  const [auth, setAuth] = useState(() => {
    const savedAuth = localStorage.getItem('auth');
    try {
      return savedAuth ? JSON.parse(LZString.decompress(savedAuth)) : { token: '' };
    } catch (e) {
      console.error("Error parsing auth from localStorage", e);
      return { token: '' };
    }
  });

  const [favoriteItem, setFavoriteItem] = useState(() => {
    const savedFav = localStorage.getItem('fav');
    try {
      const decompressedFav = savedFav ? LZString.decompress(savedFav) : null;
      return decompressedFav ? JSON.parse(decompressedFav) : [];
    } catch (e) {
      console.error("Error parsing favoriteItem from localStorage", e);
      return [];
    }
  });

  const [articleSaving, setAarticleSaving] = useState(() => {
    const savedArticle = localStorage.getItem('savve');
    try {
      const decompressedArticle = savedArticle ? LZString.decompress(savedArticle) : null;
      return decompressedArticle ? JSON.parse(decompressedArticle) : [];
    } catch (e) {
      console.error("Error parsing articleSaving from localStorage", e);
      return [];
    }
  });

  const [articleDet, setArticleDet] = useState([]);

  useEffect(() => {
    localStorage.setItem('auth', LZString.compress(JSON.stringify(auth)));
  }, [auth]);

  useEffect(() => {
    localStorage.setItem('fav', LZString.compress(JSON.stringify(favoriteItem)));
  }, [favoriteItem]);

  useEffect(() => {
    localStorage.setItem('savve', LZString.compress(JSON.stringify(articleSaving)));
  }, [articleSaving]);

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        articleDet,
        setArticleDet,
        favoriteItem,
        setFavoriteItem,
        articleSaving,
        setAarticleSaving,
        persantage,
        setPersantage,
        questionsAnswers,
        setQuestionsAnswers,result,setResult
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
